import { useState } from 'react'

import { DropDownItem } from 'types/components'

export const useVoucherMerchantsSelectQuery = () => {
  const [selectedMerchants, selectedMerchantsSet] = useState<DropDownItem[]>([])

  const onSelectMerchants = (itemOrItems: DropDownItem | DropDownItem[]) => {
    if (Array.isArray(itemOrItems)) {
      selectedMerchantsSet(itemOrItems)
    } else {
      selectedMerchantsSet((prev) =>
        prev.some((m) => m.value === itemOrItems.value)
          ? prev.filter((m) => m.value !== itemOrItems.value)
          : [...prev, itemOrItems]
      )
    }
  }

  return {
    selectedMerchants,
    onSelectMerchants,
  }
}